/**
 * Conexão ÚNICA de tempo real do chat da equipe (EventSource), dividida entre a
 * tela do chat e o aviso que mora no layout. Uma aba = uma conexão, por mais
 * componentes que escutem. Cai → reconecta sozinha com espera crescente.
 */
import { API_BASE } from '../services/api';

const EVENTOS = ['pronto', 'mensagem', 'atualizada', 'lido', 'digitando', 'presenca', 'canal', 'chamada', 'agenda'];
const ouvintes = new Map(); // evento → Set(fn)
let fonte = null;
let espera = 2000;
let timer = null;
let usuarios = 0;

// Conversa que está aberta NA TELA agora (o aviso não toca pra ela).
let canalAberto = null;
export function definirCanalAberto(id) { canalAberto = id || null; }
export function obterCanalAberto() { return canalAberto; }

function disparar(evento, dados) {
  const s = ouvintes.get(evento);
  if (!s) return;
  for (const fn of [...s]) { try { fn(dados); } catch (_) { /* ouvinte com erro não derruba os outros */ } }
}

function abrir() {
  if (fonte || typeof window === 'undefined' || typeof window.EventSource === 'undefined') return;
  const token = localStorage.getItem('token');
  if (!token) return;
  fonte = new window.EventSource(`${API_BASE}/equipe-chat/stream?token=${encodeURIComponent(token)}`);
  for (const ev of EVENTOS) {
    fonte.addEventListener(ev, (e) => {
      let d = null;
      try { d = JSON.parse(e.data); } catch (_) { return; }
      if (ev === 'pronto') espera = 2000;
      disparar(ev, d);
    });
  }
  fonte.onerror = () => {
    try { fonte.close(); } catch (_) { /* ok */ }
    fonte = null;
    disparar('desconectado', {});
    if (usuarios > 0 && !timer) {
      timer = setTimeout(() => { timer = null; abrir(); }, espera);
      espera = Math.min(espera * 2, 30000);
    }
  };
}

function fechar() {
  if (timer) { clearTimeout(timer); timer = null; }
  if (fonte) { try { fonte.close(); } catch (_) { /* ok */ } fonte = null; }
}

/** Escuta um evento; devolve a função que para de escutar. */
export function ouvir(evento, fn) {
  if (!ouvintes.has(evento)) ouvintes.set(evento, new Set());
  ouvintes.get(evento).add(fn);
  return () => { ouvintes.get(evento)?.delete(fn); };
}

/** Quem precisa da conexão chama `usar()` e guarda o retorno pra soltar. */
export function usar() {
  usuarios += 1;
  abrir();
  return () => {
    usuarios = Math.max(0, usuarios - 1);
    if (!usuarios) fechar();
  };
}

export function conectado() { return !!fonte && fonte.readyState === 1; }
